import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import ManageHistoryOutlinedIcon from "@mui/icons-material/ManageHistoryOutlined";
import AccessibilityIcon from "@mui/icons-material/Accessibility";

export const drawerWidth = 350;

export const PERMISSIONS = {
  "ticket": [
    "ticket_onboard",
    "ticket_offboard",
    "ticket_manage_site",
    "ticket_manage_sharedmailbox",
    "ticket_new_siteuser",
    "ticket_others",
  ],
  "admin": [
    "admin_user_permission",
    "admin_system_credential",
    "admin_collector",
  ],
};

export const FORM_TYPE = {
  ONBOARD_EMPLOYEE: {
    TYPE: "ONBOARD-EMPLOYEE",
    TITLE: "onboardFormTitle",
    ICON: PersonAddAltOutlinedIcon,
    PERMISSION: PERMISSIONS.ticket[0],
  },
  OFFBOARD_EMPLOYEE: {
    TYPE: "OFFBOARD-EMPLOYEE",
    TITLE: "offboardFormTitle",
    ICON: PersonOffOutlinedIcon,
    PERMISSION: PERMISSIONS.ticket[4],
  },
  NEW_SITE_TEAM: {
    TYPE: "NEW-SITE-TEAM-REQUEST",
    TITLE: "newSiteTeamFormTitle",
    ICON: GroupsOutlinedIcon,
    PERMISSION: PERMISSIONS.ticket[2],
  },
  MANAGE_SITE_USERS: {
    TYPE: "ADD-REMOVE-SITE-USERS",
    TITLE: "manageSiteFormTitle",
    ICON: ManageAccountsOutlinedIcon,
    PERMISSION: PERMISSIONS.ticket[1],
  },
  MANAGE_SHARED_MAILBOXES: {
    TYPE: "ADD-MODIFY-SHARED-MAILBOXES",
    TITLE: "manageMailboxFormTitle",
    ICON: EmailOutlinedIcon,
    PERMISSION: PERMISSIONS.ticket[3],
  },
  OTHER_REQUEST: {
    TYPE: "OTHER-REQUEST",
    TITLE: "otherRequestFormTitle",
    ICON: EditNoteOutlinedIcon,
    PERMISSION: PERMISSIONS.ticket[5],
  },
};


export const ROUTES = {
  HOME: "/",
  REPORTS: "/reports",
  LOGOUT: "/logout",
  FORMS: "/form",
  ERROR: "/error",
  ADMIN: {
    USER_PERMISSIONS: "/admin/userPermissions",
    SYSTEM_CREDENTIALS: "/admin/systemCredentials",
    COLLECTORS: "/admin/collectors",
  },
  NOT_FOUND: "/not-found",
};

export const ADMIN_TYPE = {
    ADMIN_USER_PERMISSION: {
      TITLE: "userPermissionsTitle",
      ICON: AccessibilityIcon,
      PATH: ROUTES.ADMIN.USER_PERMISSIONS,
      PERMISSION: PERMISSIONS.admin[0],
    },
    ADMIN_COLLECTOR: {
      TITLE: "collectorsTitle",
      ICON: ManageHistoryOutlinedIcon,
      PATH: ROUTES.ADMIN.COLLECTORS,
      PERMISSION: PERMISSIONS.admin[1],
    },
    ADMIN_SYSTEM_CREDENTIAL: {
      TITLE: "systemCredentialsTitle",
      ICON: VpnKeyOutlinedIcon,
      PATH: ROUTES.ADMIN.SYSTEM_CREDENTIALS,
      PERMISSION: PERMISSIONS.admin[1],
    },
  };
